<template>
  <div class="bg-white rounded-lg border border-gray-200 p-4 mb-6">
    <h3 class="text-sm font-semibold mb-3 text-gray-900">
      Step 3: Configure InfoTag Import
    </h3>

    <div class="space-y-4">
      <!-- InfoTagType Selection -->
      <MappedSelect
        label="InfoTagType *"
        :model-value="config.infotag_type_id"
        :options="infotagTypeOptions"
        placeholder="-- Select InfoTagType --"
        numeric
        @update:model-value="updateConfig('infotag_type_id', $event)"
      />

      <!-- InfoTag Name Column -->
      <div>
        <MappedSelect
          label="InfoTag name column *"
          :model-value="config.infotag_name_column"
          :options="sheetColumns"
          placeholder="-- Select column --"
          @update:model-value="updateConfig('infotag_name_column', $event)"
        />
        <p class="text-xs text-gray-500 mt-1">Column containing the tag values to assign</p>
      </div>

      <!-- Entity Identifier -->
      <div class="p-3 bg-gray-50 rounded border border-gray-100">
        <h4 class="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-2">
          Entity identifier *
        </h4>
        <div class="grid grid-cols-2 gap-3 mb-3">
          <MappedSelect
            label="Identifier column"
            :model-value="config.entity_identifier_column"
            :options="sheetColumns"
            placeholder="-- Select column --"
            @update:model-value="updateConfig('entity_identifier_column', $event)"
          />
          <MappedSelect
            label="Identifier type"
            :model-value="config.entity_identifier_type"
            :options="identifierTypes"
            placeholder="-- Select type --"
            @update:model-value="updateConfig('entity_identifier_type', $event)"
          />
        </div>
        <p class="text-xs text-gray-500 mb-3">Which entity does each row's tag belong to?</p>

        <FuzzyMatchControl
          label="Enable fuzzy matching for entity identifiers"
          :enabled="config.use_entity_fuzzy_matching"
          :threshold="config.entity_fuzzy_threshold"
          @update:enabled="updateConfig('use_entity_fuzzy_matching', $event)"
          @update:threshold="updateConfig('entity_fuzzy_threshold', $event)"
        />
      </div>

      <!-- Tag Name Fuzzy Matching -->
      <FuzzyMatchControl
        label="Enable fuzzy matching for InfoTag names"
        :enabled="config.use_fuzzy_matching"
        :threshold="config.fuzzy_threshold"
        @update:enabled="updateConfig('use_fuzzy_matching', $event)"
        @update:threshold="updateConfig('fuzzy_threshold', $event)"
      />

      <!-- Overwrite Option -->
      <div class="p-3 bg-red-50 rounded border border-red-200">
        <label class="inline-flex items-center gap-2 text-sm font-medium text-gray-700">
          <input
            type="checkbox"
            :checked="config.overwrite"
            @change="updateConfig('overwrite', $event.target.checked)"
          />
          Overwrite existing InfoTags
        </label>
        <p class="text-xs text-gray-500 mt-1.5">
          If enabled, existing InfoTagRelationships of this type will be replaced with new values from the import.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import MappedSelect from './controls/MappedSelect.vue';
import FuzzyMatchControl from './controls/FuzzyMatchControl.vue';

export default {
  name: 'InfoTagImportConfig',
  components: { MappedSelect, FuzzyMatchControl },

  props: {
    config: {
      type: Object,
      required: true
    },
    infotagTypes: {
      type: Array,
      required: true
    },
    sheetColumns: {
      type: Array,
      required: true
    },
    identifierTypes: {
      type: Array,
      required: true
    }
  },

  emits: ['update:config'],

  computed: {
    infotagTypeOptions() {
      return this.infotagTypes.map((t) => ({ value: t.id, label: t.label }));
    },
  },

  methods: {
    updateConfig(field, value) {
      this.$emit('update:config', { ...this.config, [field]: value });
    }
  }
};
</script>
